import { extendTailwindMerge } from 'tailwind-merge'

export const tw = extendTailwindMerge<'fontSpacing' | 'typography'>({
  extend: {
    classGroups: {
      fontSpacing: ['font-condensed', 'font-regular'],
      typography: [
        'typography-h1',
        'typography-h2',
        'typography-h3',
        'typography-h4',
        'typography-h5',
        'typography-h6',
        'typography-label',
        'typography-unset'
      ]
    }
  }
})
